import getStoreProperty from "components/ProjectNonSpecificComponents/DevTools/Functions/getStoreProperty"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { objectLength } from "components/ProjectNonSpecificComponents/Functions/objectLength"
import { ADMIN_PANEL_FORM_IDS } from "components/ProjectSpecificComponents/Constants/ADMIN_PANEL_CONSTANTS"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import scrollToId from "components/ProjectSpecificComponents/Functions/scrollToId"
import { observer } from "mobx-react"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import SideNavItem from "../atoms/SideNavItem"

interface Props {
	textHidden?: boolean
	mobileView?: boolean
}

const RequestSideNav = observer(({ textHidden = false, mobileView = false }: Props) => {
	const store = useStore()
	const { instanceAnonymousUsers, showAdminPanelForms } = store
	const { t } = useTranslation()

	return (
		<HyperDiv
			width="100%"
			direction="column"
			padding={mobileView ? "" : "0 .75rem"}
			alignedRight={!textHidden}
			centeredY={textHidden}
		>
			{/* Length check is required to highlight side navigation */}
			<>
				<SideNavItem
					iconKey="item-type"
					textHidden={textHidden}
					children={t("forms.header.item")}
					onClick={() => scrollToId(ADMIN_PANEL_FORM_IDS.item)}
					sectionKey="item"
				/>
				{showAdminPanelForms && (
					<>
						<SideNavItem
							iconKey="layers"
							textHidden={textHidden}
							children={t("forms.header.collection")}
							onClick={() => scrollToId(ADMIN_PANEL_FORM_IDS.collection)}
							sectionKey="collection"
						/>
						<SideNavItem
							iconKey="blank-page"
							textHidden={textHidden}
							children={t("forms.header.newRequestForm")}
							onClick={() => scrollToId(ADMIN_PANEL_FORM_IDS.newRequestForm)}
							sectionKey="newRequestForm"
						/>
						{!instanceAnonymousUsers && (
							<SideNavItem
								iconKey="table"
								textHidden={textHidden}
								children={t("forms.header.requestTableForm")}
								onClick={() => scrollToId(ADMIN_PANEL_FORM_IDS.requestTableForm)}
								sectionKey="requestTableForm"
							/>
						)}
						{!instanceAnonymousUsers && (
							<SideNavItem
								iconKey="form"
								textHidden={textHidden}
								children={t("forms.header.savedRequestForm")}
								onClick={() => scrollToId(ADMIN_PANEL_FORM_IDS.savedRequestForm)}
								sectionKey="savedRequestForm"
							/>
						)}
						{/* <SideNavItem
							iconKey="email"
							textHidden={textHidden}
							children={t("forms.header.email")}
							sectionKey="email"
						/> */}
					</>
				)}
			</>
		</HyperDiv>
	)
})

export default RequestSideNav
